import React from 'react'
import { getConfig, FrameIn, getBrand, trackPage, getOwaTcdaoContext } from '../twd'

export default () => {
    trackPage('sell-your-bond')

    return <React.Fragment>
        <div className="container">
        <div className="row vertical-offset-lg bottom-border-row">
        <div className="col-md-12 col-xs-12">
        <FrameIn
            src={ `${getConfig('bw_service_host')}/${getBrand()}/${getOwaTcdaoContext()}/pkg_order_bond.output?p_action=S&p_source_action=H` }
        />
        </div>
        </div>
        </div>
        </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/sell-your-bond/sell-your-bond.js